import React from "react"
import PropTypes from "prop-types"
import NpsShape from "../../state/shapes/NpsShape"
import Widget from "../layout/widget/Widget"
import DoughnutChart from "../charts/generic/DoughnutChart"
import ChartComparison from "../ChartComparison"

function EmployeeNetPromotorScoreDoughnut({
  exportEndpoint,
  appliedFilters,
  data,
  subtitleKey,
  sampleSize
}) {
  const scoreIsPositive = data.currentReviewYearSummary.score >= 0
  const doughnutData = [
    {
      key: "NPSScore",
      // Make value positive so that doughnut shows slice
      value: Math.abs(data.currentReviewYearSummary.score)
    }
  ]

  const hasComparisonData = false//!!(data.previousYears[1] && data.previousYears[1].score)
  const titleKey = "Widgets.EmployeeNetPromoterScore.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.NetPromoterScoreDoughnut.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <DoughnutChart
        data={doughnutData}
        chartThreshold={100}
        prefix={scoreIsPositive ? "+" : "-"}
        hasComparison={hasComparisonData}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      >
        {hasComparisonData && (
          <ChartComparison
            baseValue={data.currentReviewYearSummary.score}
            comparisonOneValue={data.previousYears[0].score}
            comparisonOneText={data.previousYears[0].clientWorkflowName}
            comparisonTwoValue={data.previousYears[1] ? data.previousYears[1].score : null}
            comparisonTwoText={
              data.previousYears[1] ? data.previousYears[1].clientWorkflowName : null
            }
            usePercentage={false}
            increaseIsGood={false}
          />
        )}
      </DoughnutChart>
    </Widget>
  )
}

EmployeeNetPromotorScoreDoughnut.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(NpsShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default EmployeeNetPromotorScoreDoughnut



// WEBPACK FOOTER //
// ./src/components/widgets/EmployeeNetPromotorScoreDoughnut.jsx